import styled, { css } from 'styled-components';

export const ListItemContainer = styled.div`
  width: 100%;
  min-height: 72px;

  display: grid;
  align-items: center;

  ${({ theme }) => css`
    column-gap: ${theme.padding.small};
    padding: 0 ${theme.padding.input};
    background-color: ${theme.colors.grey.main};
    border-radius: ${theme.borderRadius.biggest};
  `};
`;
